import { createEvent, createStore, restore } from "effector";
import { T } from "frontend/src/lib/T";
import { persist } from "effector-storage/local";
export var audioStarted = createEvent();
export var audioStopped = createEvent();
export var audioLoadStarted = createEvent();
export var audioLoadEnded = createEvent();
var audioCurrentTimeSet = createEvent();
export var audioVolumeSet = createEvent();
export var audio = new Audio();
export var audioEnded = createEvent();
export var $audioCurrentTime = restore(audioCurrentTimeSet, 0);
export var $audioVolume = restore(audioVolumeSet, 0.5);
export var $isAudioPlaying = createStore(false);
export var $isAudioLoading = createStore(false);
$isAudioPlaying.on(audioStarted, T).reset(audioStopped);
$isAudioLoading.on(audioLoadStarted, T).reset(audioLoadEnded);
audio.addEventListener("timeupdate", function () {
    return audioCurrentTimeSet(audio.currentTime);
});
$audioVolume.watch(function (volume) { return (audio.volume = volume); });
audio.addEventListener("ended", function () { return audioEnded(); });
persist({
    store: $audioVolume,
    key: "volume",
});
